import { Text } from 'pixi.js';
import { gameConfig } from '../config/gameConfig.js';

/**
 * Optional debug: URL ?debug=1, keyboard ` (backtick) toggles overlays.
 * `forceNextGrid(grid)` schedules a deterministic outcome.
 */
export class DebugMode {
  constructor() {
    const params = new URLSearchParams(window.location.search);
    this.enabled =
      gameConfig.debug.defaultEnabled || params.get('debug') === '1' || params.get('debug') === 'true';
    /** @type {number[][] | null} */
    this._forcedGrid = null;
    /** @type {Text[]} */
    this._overlayLabels = [];
    this._overlayVisible = this.enabled;
  }

  toggle() {
    this.enabled = !this.enabled;
    this._overlayVisible = this.enabled;
    this._syncOverlays();
  }

  /**
   * @param {number[][]} grid column-major 5x3
   */
  forceNextGrid(grid) {
    this._forcedGrid = grid;
  }

  /** @returns {number[][] | null} */
  consumeForcedGrid() {
    const g = this._forcedGrid;
    this._forcedGrid = null;
    return g;
  }

  /**
   * @param {import('pixi.js').Container} parent
   * @param {() => Array<{ x: number, y: number, text: string }>} getCellLabels
   */
  mountOverlay(parent, getCellLabels) {
    this._parent = parent;
    this._getCellLabels = getCellLabels;
    this._syncOverlays();
  }

  refreshOverlay() {
    this._syncOverlays();
  }

  _syncOverlays() {
    if (!this._parent || !this._getCellLabels) return;
    for (const t of this._overlayLabels) {
      this._parent.removeChild(t);
      t.destroy();
    }
    this._overlayLabels = [];
    if (!this._overlayVisible || !gameConfig.debug.showCellIndices) return;
    const entries = this._getCellLabels();
    for (const e of entries) {
      const t = new Text({
        text: e.text,
        style: {
          fontFamily: 'monospace',
          fontSize: 11,
          fill: 0xffe066,
        },
      });
      t.x = e.x;
      t.y = e.y;
      t.alpha = 0.85;
      this._parent.addChild(t);
      this._overlayLabels.push(t);
    }
  }
}
